<div style="position: fixed; bottom: 0; right: 0; z-index: 1030">
    <ngb-toast
            (click)="toast.onClick(toast)"
            (hidden)="toastService.remove(toast)"
            *ngFor="let toast of toastService.toasts"
            [autohide]="true"
            [class]="toast.classname"
            [delay]="toast.delay || 5000"
    >
        <ng-template [ngIfElse]="text" [ngIf]="isTemplate(toast)">
            <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
        </ng-template>

        <ng-template #text>
            <div [innerHTML]="toast.textOrTpl"></div>
        </ng-template>
    </ngb-toast>
</div>